import Atc from '../../../../Lib/ATC';

import userAddToWishListLocalWeb from './addToWishlistLocalWeb';
import userGetWishlistLocalWeb from './getWishlistLocalWeb';
import userRemoveFromWishlistLocalWeb from './removeFromWishlistLocalWeb';
import userGetUserInfo from './getUserInfo';
import userUpdateUserInfo from './updateUserInfo';
import userUpdateUserInfoJemisys from './updateUserInfoJemisys';
import userGetUserIP from './getUserIP';
import userGetMemberPoints from './getMemberPoints';
import userUpdatePassword from './updatePassword';
import userGetOrderHistory from './getOrderHistory';
import userGetOrderHistoryDetails from './getOrderHistoryDetails';

export const ErrorTypes = Atc.UseCases.Types.JemisysErrorTypes.UserErrorTypes;

export default {
    userAddToWishListLocalWeb,
    userGetWishlistLocalWeb,
    userRemoveFromWishlistLocalWeb,
    userGetUserInfo,
    userGetUserIP,
    userGetMemberPoints,
    userUpdateUserInfo,
    userUpdateUserInfoJemisys,
    userUpdatePassword,
    userGetOrderHistory,
    userGetOrderHistoryDetails,
};
